var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventStrategy } from './EventStrategy';
var PageEventStrategy = /** @class */ (function (_super) {
    __extends(PageEventStrategy, _super);
    function PageEventStrategy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.previousUrl = location.href;
        _this.handlePageView = function () {
            var _a;
            (_a = _this.onEventTriggered) === null || _a === void 0 ? void 0 : _a.call(_this, {
                condition: true,
                props: _this.props,
                data: { href: location.href }
            });
        };
        return _this;
    }
    PageEventStrategy.prototype.start = function () {
        var _this = this;
        if (this.isConditionMet()) {
            this.handlePageView();
        }
        var observer = new MutationObserver(function () {
            if (_this.previousUrl !== location.href) {
                _this.previousUrl = location.href;
                if (_this.isConditionMet()) {
                    _this.handlePageView();
                }
            }
        });
        observer.observe(document, { subtree: true, childList: true });
    };
    PageEventStrategy.prototype.isConditionMet = function () {
        var props = this.props;
        // wildcard match should only care about origin + path
        var url = location.origin + location.pathname;
        return this.isUrlMatch(url, props.urlPattern);
    };
    PageEventStrategy.prototype.isUrlMatch = function (str, rule) {
        var escapeRegex = function (str) { return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&'); };
        // eslint-disable-next-line security/detect-non-literal-regexp
        return new RegExp('^' + rule.split('*').map(escapeRegex).join('.*') + '$').test(str);
    };
    return PageEventStrategy;
}(EventStrategy));
export { PageEventStrategy };
//# sourceMappingURL=PageEventStrategy.js.map